import React, { useRef, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getWebstatsHead } from 'design-comuni-plone-theme/actions';

function SiteControlpanelExtra() {
    const dispatch = useDispatch();
    const webstatsHead = useSelector(
        (state) => state.webstatsHeadReducer?.result,
    );

    useEffect(() => {
        dispatch(getWebstatsHead());
    }, []);

    useEffect(() => {
        if (!webstatsHead || typeof webstatsHead !== 'string') return;
        const js = webstatsHead.replace(/<\/?script>/g, '');
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.async = true;
        script.text = js;
        document.head.appendChild(script);
    }, [webstatsHead]);

    return null;
}

export default SiteControlpanelExtra;
